/* eslint-disable-no-extraneous-dependencies */
import { TipoCreciC } from "screens/perfilAutonomo/utils";
import { z } from "zod";

export const schema = z
  .object({
    bandeira: z.string().optional(),
    idTipoCreci: z.string().min(1),
    numero: z.string().min(1),
    dataVencimento: z.date().nullable(),
    carteiraFrente: z.string().optional(),
    carteiraVerso: z.string().optional(),
    isJuridico: z.boolean().optional(),
    escola: z.string().optional(),
    razaoSocial: z.string().optional(),
    numeroCnpj: z.string().optional(),
    enderecoFiscal: z.string().optional(),
    certidaoCreciJuridico: z.string().nullable().optional(),
    cartaoCnpj: z.string().nullable().optional(),
  })
  .refine(
    (data) => {
      if (
        data.idTipoCreci === TipoCreciC.DEFINITIVO &&
        data.bandeira !== "vivaz"
      ) {
        return typeof data.isJuridico === "boolean";
      }
      return true;
    },
    {
      message: "Obrigatório",
      path: ["isJuridico"],
    }
  )
  .refine(
    (data) => {
      if (data.isJuridico && data.bandeira !== "vivaz") {
        return (
          data.razaoSocial &&
          data.numeroCnpj &&
          data.enderecoFiscal &&
          data.certidaoCreciJuridico &&
          data.cartaoCnpj
        );
      }
      return true;
    },
    {
      message: "Todos os campos de CRECI jurídico devem ser preenchidos",
      path: ["isJuridico"],
    }
  );

export type EditCreciFormValues = z.infer<typeof schema>;
